import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5adfdbda&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5adfdbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adfdbda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5adfdbda')) {
      api.createRecord('5adfdbda', component.options)
    } else {
      api.reload('5adfdbda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5adfdbda&scoped=true&", function () {
      api.rerender('5adfdbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/saas/layoutSystem/index.vue"
export default component.exports